import { Clock } from 'lucide-react';
import { Dialog } from '../ui/dialog';

export default function InactivityWarningDialog({ open, secondsLeft, onStayLoggedIn }) {
  const minutes = Math.floor(secondsLeft / 60);
  const seconds = secondsLeft % 60;
  const timeDisplay = `${minutes}:${seconds.toString().padStart(2, '0')}`;
  const isUrgent = secondsLeft <= 10;

  return (
    <Dialog open={open} onOpenChange={(isOpen) => { if (!isOpen) onStayLoggedIn(); }}>
      <div className="bg-white dark:bg-dark-bg-secondary rounded-lg shadow-xl max-w-sm w-full mx-4 p-6">
        <div className="flex items-center gap-3 mb-4">
          <div className="w-10 h-10 bg-amber-100 dark:bg-amber-900/30 rounded-full flex items-center justify-center">
            <Clock className="w-5 h-5 text-amber-600 dark:text-amber-400" />
          </div>
          <h2 className="text-lg font-semibold text-gray-900 dark:text-white">
            Session Expiring
          </h2>
        </div>

        <p className="text-sm text-gray-600 dark:text-gray-400 mb-4">
          You will be logged out due to inactivity.
        </p>

        <div className={`text-center text-3xl font-mono font-bold mb-6 ${
          isUrgent
            ? 'text-red-600 dark:text-red-400'
            : 'text-gray-900 dark:text-white'
        }`}>
          {timeDisplay}
        </div>

        <button
          onClick={onStayLoggedIn}
          className="w-full px-4 py-2.5 bg-emerald-600 text-white rounded-lg hover:bg-emerald-700 transition font-medium"
        >
          Stay Logged In
        </button>
      </div>
    </Dialog>
  );
}
